import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-about-to-expire-window',
  templateUrl: './about-to-expire-window.component.html',
  styleUrls: ['./about-to-expire-window.component.css']
})
export class AboutToExpireWindowComponent implements OnInit {

  constructor(private titleService: Title) { }

  ngOnInit() {
    this.titleService.setTitle('/expoutofstock/abouttoexpire');
  }

}
